import * as React from 'react';
import {AlertTypes, apiClient, DynamicDatagrid, Grid, setAlert, MuiDataGrid, Paper} from "@leap4/frontend";

import {INetworkPartner} from "@leap4/entities-discrepancy-common";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {urlService} from "../../../routing/urlsService";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
export interface INetworkPartnerTableProps{
    baseUrl: string
    data: any
    sideColumn: boolean
    partnerColumn: boolean
}


//TODO: add is loading
export const DataTable = (props:INetworkPartnerTableProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<INetworkPartner[]>(null)
    const dispatch = useDispatch();


    const fetchData = () => {
        (async () => {
            try {
                setIsLoading(true);
                const response = (await apiClient.post(props.baseUrl, props.data))
                setData(response.data)
            } catch (err) {
                setAlert({msg: "Couldn't load network partners to assign", type: AlertTypes.FAILURE, d: dispatch})
            } finally {
                setIsLoading(false);
            }
        })()
    }

    useEffect(fetchData, [])
    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 500,
            renderCell: (params: GridRenderCellParams) => {
                return (params as any).name
            }

        },
        {
            field: 'companyId',
            headerName: 'Company Id',
            width: 170,
            renderCell: (params) => {
                return (params as any).companyId
            }
        },
        {
            field: 'dataPoint',
            headerName: 'Data Point',
            width: 170,
            renderCell: (params) => {
                return <Link to={urlService.editDataPoint(params.value?.id.toString())}><strong
                >{params.value?.name}</strong></Link>
            }
        }
    ];
    {props.sideColumn && columns.push(
        {
            field: 'side',
            headerName: 'Side',
            width: 170,
            renderCell: (params) => {
                return (params as any).side
            }
        }
    )}

    {props.partnerColumn && columns.push(
        {
            field: 'partner',
            headerName: 'Partner',
            width: 170,
            renderCell: (params) => {
                return <Link to={urlService.editPartner(params.value?.id.toString())}><strong
                >{params.value?.name}</strong></Link>
            }
        }
    )}

    function createRowData(item: INetworkPartner) {
        let obj = {
            id: item._id,
            name: item.name,
            companyId: item.companyId,
            dataPoint: item.dataPoint,
        }
        if (props.sideColumn){
            obj["side"] = item.side
        }
        if (props.partnerColumn){
            obj["partner"] = item.partner
        }
        return obj
    }

    const rows = data && data.map(row => createRowData(row));

    return (
        <>
            {
                rows&&<Grid container justifyContent={"space-around"} sm={12} >
                    <Grid item xs={12}>
                        <Paper elevation={5} style={{borderRadius: "16px", boxShadow: "none"}}>
                            <DynamicDatagrid rows={rows}
                                             columns={columns}
                                             loading={isLoading}
                                             loadError={false}
                                             refreshFunc={fetchData}
                                             pageSize={100}
                                             style={{minHeight: `75vh`, width: '100%'}}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            }

        </>
    );
}
